<div class="title-and-link">
  <h1 class="main-title">Configure Graduation Plan</h1>
  <a
    href="https://community.schoolzilla.com/t/data-configuration-settings/1944"
    target="_blank"
    class="need-help-link"
    title="Open help page in new tab"
    >Need help?</a
  >
</div>
<div>
  <p>
    Select one graduation plan below. We populate this list of graduation plans
    based on values in your student information system.
  </p>
  <p>
    We will utilize your selection in two ways. First, we will associate it with
    student records in the data warehouse, if and only if, a student record does
    not already have an associated plan in the student information system.
    Second, we will use it to calculate a Credits Earned toward Graduation
    metric. We can associate only one plan with a Credits Earned metric.
  </p>
  <p>
    Please allow up to 24 hours for data to reflect changes. Contact support if
    you have questions.
  </p>
</div>
<div>
  <mat-card
    *ngIf="errorDetails"
    class="load-error"
    [innerHTML]="errorDetails"
  ></mat-card>
</div>
<div *ngIf="gradPlans">
  <table mat-table [dataSource]="gradPlans" class="grad-plan-table">
    <!-- Radio Button Column -->
    <ng-container matColumnDef="radioButton">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <mat-radio-group
          [value]="defaultGradPlanID"
          (change)="updateDefaultGradPlan(element.GraduationPlanID)"
        >
          <mat-radio-button
            [value]="element.GraduationPlanID"
          ></mat-radio-button>
        </mat-radio-group>
      </td>
    </ng-container>

    <ng-container
      *ngFor="let column of displayedColumns"
      [matColumnDef]="column.id"
    >
      <th mat-header-cell *matHeaderCellDef>{{ column.name }}</th>
      <td
        mat-cell
        *matCellDef="let element"
        [ngClass]="{
          'highlighted-name':
            column.id == 'GraduationPlanName' && element.IsDefaultGraduationPlan
        }"
      >
        {{ element[column.id] }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="getColumnIds()"></tr>
    <tr mat-row *matRowDef="let row; columns: getColumnIds()"></tr>
  </table>
</div>
